<template>
  <div
    :class="`selector ${compact ? 'selector--compact' : ''}`"
    :style="extra_style"
  >
    <label
      v-if="label"
      class="text-primary semibold d-none d-lg-block d-xl-block"
    >
      {{ label }}
    </label>
    <b-dropdown
      variant="ghost"
      :class="`btn-block ${button_classes}`"
      :disabled="disabled"
      right
    >
      <template #button-content>
        <span class="d-flex flex-column w-100">
          <span class="selector-button w-100 overflow-hidden">
            <span
              v-if="optionSelected"
              class="d-flex align-items-center truncate-text-overflow"
              style="gap: 5px; padding-right: 8px"
            >
              <vb-icon
                v-if="optionSelected.icon"
                v-bind="optionSelected.icon"
                :size="16"
                class="mr-1"
              />
              <span v-if="optionSelected.label">
                {{ optionSelected.label }}
              </span>
            </span>
            <span
              v-else-if="placeholder"
              class="d-inline-block truncate-text-overflow"
            >
              <vb-icon
                v-if="placeholder.icon"
                :name="placeholder.icon"
                :size="16"
                class="mr-1"
              />
              <span v-if="placeholder.label">{{ placeholder.label }}</span>
            </span>
            <span class="thin d-flex align-items-center" style="gap: 5px">
              <span
                v-if="showProgress"
                class="d-none d-lg-inline-block d-xl-inline-block"
              >
                {{ currentIndex + 1 }} / {{ options.length }}
              </span>
              <vb-icon name="chevron-down" :size="compact ? 12 : 16" />
            </span>
          </span>
          <span class="selector-button w-100 d-flex d-lg-none d-xl-none">
            <slot name="inside"></slot>
          </span>
        </span>
      </template>
      <b-dropdown-item
        v-for="(o, i) in options"
        :key="o.value"
        href="#"
        :disabled="o.disabled"
        class="w-100"
        @click="() => onChange(o.value)"
      >
        <hr v-if="showDividers && i > 0" class="m-0 mb-1" />
        <span class="w-100" v-html="o.html || o.label"> </span>
      </b-dropdown-item>
    </b-dropdown>
    <div class="d-none d-lg-flex d-xl-flex">
      <slot name="after"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'selector',
    components: {},
    props: {
      label: String,
      selected: String,
      options: Array,
      onChange: Function,

      disabled: Boolean,
      showProgress: Boolean,
      showDividers: Boolean,

      button_classes: {
        type: String,
        default: () => '',
      },
      placeholder: {
        type: Object,
        default: () => ({}),
      },
      compact: {
        type: Boolean,
        default: false,
      },
      extra_style: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      currentIndex() {
        return (this.options || []).findIndex((o) => o.value === this.selected);
      },
      optionSelected() {
        if (!this.options || !this.options.length || this.currentIndex < 0) {
          return undefined;
        }
        return this.options[this.currentIndex];
      },
    },
  };
</script>

<style lang="scss">
  .selector {
    button {
      padding: 12px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 10px;
      border: 1px solid $light-gray;
      min-width: var(--button-min-width);
    }

    .rounded-full {
      button {
        padding: 12px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 25px;
        border: 2px solid $light-gray;
      }
    }

    .dropdown-toggle::after {
      display: none;
    }

    .dropdown-menu {
      &:focus {
        outline: none;
      }

      margin-top: 5px;
      min-width: 140%;
      @include media-breakpoint-down(md) {
        min-width: 100%;
      }
      box-shadow: $box-shadow;
      padding: 8px 0;
      max-height: 300px;
      overflow-y: auto;
      @include scrollbar();

      li {
        min-width: 100%;
        font-size: 14px;
      }

      *:hover {
        background-color: transparent;
        color: var(--primary);
      }

      *:active {
        background-color: $gray-100;
      }

      *:visited {
        color: inherit;
      }
    }

    &--compact {
      button {
        font-size: 14px;
        padding: 5px 10px;
        display: flex;
        justify-content: space-between;
        gap: 10px;
        align-items: center;
        border-radius: 10px;
        border: 1px solid $light-gray;
        min-width: var(--button-min-width);
      }

      .dropdown-menu {
        min-width: 100%;
      }

      width: min-content;
    }
  }
  .selector-button {
    display: flex;
    justify-content: space-between;
  }
</style>
